/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import $ from 'jquery';
import BaseControl from 'scripts/base-control';
import dtm from 'scripts/services/dtm';
import statsDataView from './mini-course-stats.stache';
import statsSelectorView from './mini-course-stats-selector.stache';
import _ from 'lodash';

const updateInterval = 45 * 1000;

export const RightRailMiniCourseStats = BaseControl.extend({
    init: function () {
        this._super();

        this.$selector = this.$element.find('.js-round-selector-container');
        this.$content = this.$element.find('.js-content');

        this.getData();
        setInterval(this.getData.bind(this), updateInterval);
    },

    getData() {
        can.ajax({
            type: 'GET',
            url: this.options.controlsUrl,
            headers: {
                'Content-Type': 'application/json'
            },
            success: (data) => {
                const availableRounds = _.get(data, 'coursestatsControl.coursestatItem', [])
                    .filter(round => round.active === 'True');

                if (_.isEmpty(availableRounds)) {
                    console.error('Course control is empty');
                    return;
                }

                const currentRound = this.$element.find('.js-item.is-selected').data('round');
                const defaultRound = availableRounds.find(round => round.default === 'True') || availableRounds[0];
                const isSetCurrentRound = availableRounds.filter(round => round.type === currentRound).length > 0;

                this.$selector
                    .html(statsSelectorView({
                        availableRounds: availableRounds.map(round => round.type),
                        defaultRound: isSetCurrentRound ? currentRound : defaultRound.type
                    }));

                Promise.all(this.options.roundsUrl.map((url) => {
                    return can.ajax({
                        type: 'GET',
                        url: url,
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                })).then((result) => {
                    this.rounds = result.map(this.applyInitialContextData, this);


                    this.$selectedRound = this.$element.find('.js-item.is-selected');
                    this.$currentRoundContainer = this.$element.find('.js-current-round');

                    if (this.rounds && this.rounds.length) {
                        this.displayStats(this.$selectedRound.data('round'));
                    }
                });
            }
        });
    },

    applyInitialContextData: function(data) {
        const tournament = _.get(data, 'event.tournament', null);
        let courseData = {};
        if (tournament) {
            if (tournament.coursestats) {
                courseData = this.getCourseStatsData(tournament.courses.course, tournament.coursestats.coursestat);
            } else {
                courseData = this.getOpenCourseStatsData(tournament.course);
            }

            return courseData;
        }
    },
    dataToArray: function (data) {
        const outputData = [];
        if (can.isArray(data)) {
            return data;
        } else {
            outputData.push(data);
            return outputData;
        }
    },
    getObjByKeyName: function (list, key, value) {
        for (let i = 0, ii = list.length; i < ii; i++) {
            const item = list[i];
            if (item[key] && item[key] == value) {
                return item;
            }
        }
        return null;
    },
    getCourseStatsData: function(coursesData, statsData) {
        const courses = this.dataToArray(coursesData);
        const stats = this.dataToArray(statsData);
        const output = [];
        for (let i = 0, ii = courses.length; i < ii; i++) {
            const course = courses[i];
            const stat = stats[i];
            const statData = {
                name: course.name,
                holes: []
            };
            if (!stat || !stat.roundstats || !stat.roundstats.holestats) {
                continue;
            }
            for (let h = 0; h < 5; h++) {
                const hole = course.hole[h];
                let stats = {};

                if (stat.roundstats.holestats.length >= 0) {
                    stats = this.getObjByKeyName(stat.roundstats.holestats, 'hole', hole.no);
                } else if (stat.roundstats.holestats.hole === hole.no) {
                    stats = stat.roundstats.holestats;
                }

                if (_.isObject(stats)) {
                    hole.average = stats.avg;
                    hole.rank = stats.rank;
                    hole.hPar = stats.holepar;
                    hole.stats = stats;
                }

                statData.holes.push(hole);
            }

            const number = _.get(stat, 'roundstats.round', 'all');

            statData.number = number === 'all' ? number : parseInt(number, 10);

            output.push(statData);
        }
        return output[0];
    },
    getOpenCourseStatsData: function(courseData) {
        let statData, holes;
        const output = [];
        if (courseData && courseData.hole) {
            statData = {
                name: courseData.name,
                holes: []
            };
            holes = courseData.hole;
            for (let i = 0, ii = 5; i < ii; i++) {
                const hole = holes[i];
                const holeData = {
                    no: hole.no,
                    yards: hole.yards,
                    hPar: hole.hPar,
                    average: hole.average,
                    rank: hole.rank
                };
                statData.holes.push(holeData);

                const number = _.get(courseData, 'no', 'all');

                statData.number = number === 'all' ? number : parseInt(number, 10);
            }
            output.push(statData);
        }
        return output[0];
    },

    getRoundNumber(roundType) {
        const result = roundType.slice(-1);
        const round = parseInt(result, 10);

        return _.isNaN(round) ? 'all' : round;
    },

    displayStats: function (roundType) {
        const round = this.rounds.find(item => item.number === this.getRoundNumber(roundType));

        this.$content
            .html(statsDataView(round));
    },

    '.js-round-selector-container click': function (el) {
        $(el.context).toggleClass('is-expanded')
    },

    '.js-item click': function (el) {
        const target = $(el.context);
        const targetRound = target.data('round');
        this.$selectedRound.removeClass('is-selected');
        this.$selectedRound = target.addClass('is-selected');
        this.$currentRoundContainer.html(targetRound);
        this.displayStats(targetRound);
        dtm.trackRightRailDropdownSelection('RightRailMiniCourseStats');
    },

    '.s-btn click': function (el) {
        dtm.trackRightRailLinkToFullClick('RightRailMiniCourseStats');
    }
});
